<template>
  <div class="ui-phylactery">
    <div class="inner">
      <div class="bubble">
        <div class="px-16 pb-8">
          <p class="paragraph-xl text-center text-primary">
            <slot />
          </p>
        </div>
      </div>
      <SvgMascot class="mascot" />
    </div>
  </div>
</template>

<style lang="postcss">
.ui-phylactery {
  @apply flex justify-center;
  .inner {
    @apply relative pb-[320px] md:pb-[160px];
  }
  .bubble {
    @apply max-w-[405px] h-[345px];
    @apply flex flex-col justify-center;
    @apply bg-contain bg-center bg-no-repeat bg-[url(@/svg/bg-bubble-mobile.svg)] md:bg-[url(@/svg/bg-bubble-desktop.svg)];
    @apply mr-0 md:ml-auto md:mr-[200px];
  }
  .mascot{
    @apply absolute bottom-0 left-1/2 -translate-x-1/2 md:left-auto md:translate-x-0 md:right-0 h-[320px];
  }
}
</style>
